if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.touchStartX = 0;
        this.touchStartY = 0;
        this.handleTouchStart = this.handleTouchStart.bind(this);
        this.handleTouchEnd = this.handleTouchEnd.bind(this);
        this.updateNavPosition = this.updateNavPosition.bind(this);
      }

      connectedCallback() {
        super.connectedCallback();
        const container = this.querySelector('[role="document"]');
        if (container) {
          container.addEventListener('touchstart', this.handleTouchStart, { passive: true });
          container.addEventListener('touchend', this.handleTouchEnd, { passive: true });
        }

        this.navGroup = this.querySelector('[data-modal-nav-group]');

        this.querySelectorAll('[data-modal-nav]').forEach((button) => {
          // ModalDialog closes on any mouse pointerup outside the media itself;
          // these nav buttons live outside it too, so stop it reaching that
          // listener or clicking "next" would immediately close the modal.
          button.addEventListener('pointerup', (event) => event.stopPropagation());
          button.addEventListener('click', (event) => {
            event.preventDefault();
            this.showAdjacentMedia(button.dataset.modalNav === 'next' ? 1 : -1);
          });
        });

        window.addEventListener('resize', this.updateNavPosition);
      }

      // Contained images/videos don't fill the viewport, so a fixed corner
      // position for the nav buttons leaves a large gap under the image
      // instead of sitting right against it — this measures where the
      // active media actually ends and positions the group there instead.
      updateNavPosition() {
        if (!this.navGroup) return;
        const activeMedia = this.querySelector('[data-media-id].active');
        if (!activeMedia) return;
        const bottom = activeMedia.getBoundingClientRect().bottom;
        this.navGroup.style.setProperty('--modal-nav-top', `${bottom}px`);
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        this.setActiveMedia(activeMedia);
      }

      setActiveMedia(activeMedia) {
        if (!activeMedia) return;
        this.querySelectorAll('[data-media-id]').forEach((element) => {
          if (element !== activeMedia) element.classList.remove('active');
        });
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();

        // Run after layout settles (image load, scroll, template swap) so
        // the measurement reflects where the media actually ends up.
        requestAnimationFrame(this.updateNavPosition);
      }

      getMediaElements() {
        return Array.from(this.querySelectorAll('[data-media-id]'));
      }

      showAdjacentMedia(direction) {
        const mediaElements = this.getMediaElements();
        const currentIndex = mediaElements.findIndex((element) => element.classList.contains('active'));
        if (currentIndex === -1) return;
        const nextIndex = (currentIndex + direction + mediaElements.length) % mediaElements.length;
        window.pauseAllMedia();
        this.setActiveMedia(mediaElements[nextIndex]);
      }

      handleTouchStart(event) {
        if (event.touches.length > 1) return;
        this.touchStartX = event.touches[0].clientX;
        this.touchStartY = event.touches[0].clientY;
      }

      handleTouchEnd(event) {
        if (!this.touchStartX) return;
        const touch = event.changedTouches[0];
        const deltaX = touch.clientX - this.touchStartX;
        const deltaY = touch.clientY - this.touchStartY;
        this.touchStartX = 0;
        this.touchStartY = 0;

        const swipeThreshold = 50;
        if (Math.abs(deltaX) < swipeThreshold || Math.abs(deltaX) < Math.abs(deltaY)) return;

        this.showAdjacentMedia(deltaX < 0 ? 1 : -1);
      }
    }
  );
}
